import { render } from "./h5Vip.vue?vue&type=template&id=f9e4a4d8&scoped=true&ts=true"
import script from "./h5Vip.vue?vue&type=script&lang=ts"
export * from "./h5Vip.vue?vue&type=script&lang=ts"

import "./h5Vip.vue?vue&type=style&index=0&id=f9e4a4d8&scoped=true&lang=css"

import exportComponent from "D:\\waibao\\lsjy-h5\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f9e4a4d8"]])

export default __exports__